import type { FaireProductEntity } from "../../entity_types/product";

export const p_t72fwtq7a9: FaireProductEntity = {
  token: "p_t72fwtq7a9",
  type: "product",
  name: "Tiffin Lunch Box - Small 3 Layer",
  brandToken: "b_6xvu4qtx",
  brandName: "Verve Culture",
  imageUrl:
    "https://cdn.faire.com/fastly/8aaa24adc0eff3212ee5537dbd7e32cbb90a63debc218cde37158a6e28af3ebc.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/bc1ed36117dcc39deaec49de520c1fbeca3f82e6467ec613bbf43a8f464efbb8.jpeg",
    "https://cdn.faire.com/fastly/20c36308ee3b53d24974b61065144a467bc95a7e277d100cdd7e21b0a55d7e5c.jpeg",
    "https://cdn.faire.com/fastly/dbf21ca07ce02d38f7668e878bf1228734822bb083e94b64dc3d0a1faeffecf1.jpeg",
    "https://cdn.faire.com/fastly/54a0068892c85e854abbf9c75c523b08205e71aa8e4be9cf6399223696b1f5fb.jpeg",
    "https://cdn.faire.com/fastly/54a2fd0c76ca18335d5daf8512a8b5484c2d537e93c4884870bfb437bc15353f.jpeg",
    "https://cdn.faire.com/fastly/aca695869724343b7e39fe23ae186d1f7a7d92e22c56ef7da667e5e0914eb3de.jpeg",
    "https://cdn.faire.com/fastly/71f8ea341723f4e1a5706e3daa385c34786624cf20a8bdfd35c2ed96d0772457.jpeg",
    "https://cdn.faire.com/fastly/2a4657426a3368a6642b5fbe397404e969e2b4b7bd6f801708ba3da925753407.jpeg",
    "https://cdn.faire.com/fastly/cdd7a971448a5f162a1f59d595d1bd3baecad75a90c2154f84dca33eb7e9bd25.jpeg",
  ],
  priceDollars: 22.5,
  description:
    "Whether you're picnicking in the park, having lunch at the office, or enjoying a family outing, our Punjabi Tiffin Boxes are a versatile companion that adds a touch of Indian elegance to your dining experience. It's also an ideal gift for anyone who appreciates the beauty of functional artistry.\n\nOur Punjabi Tiffin Box features three thoughtfully designed stainless steel compartments, offering ample space to carry a diverse array of dishes. Whether you're enjoying a multi-course meal, a selection of snacks, or an assortment of your favorite flavors, this tiffin box makes it possible.\n\nOur Punjabi Tiffin Box features three thoughtfully designed stainless steel compartments, offering ample space to carry a diverse array of dishes. Whether you're enjoying a multi-course meal, a selection of snacks, or an assortment of your favorite flavors, this tiffin box makes it possible.\n\nGive a nod to the idea that food isn't just sustenance; it's a cultural connection and an expression of love.",
  tags: [],
  msrpDollars: 45,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-04-05T16:55:05.976Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
